export default __webpack_public_path__ + "static/media/logout.6fde05a9.svg";